/**
 * Factory function to initialize an address search autocomplete
 * @param {String} elementId - name of the input element
 * @param {String} key - SmartyStreets auth id
 * @param {Object} options
 * @param {String} options.state (optional) - the state to use for filtering/preference
 * @param {String} options.city (optional) - the city to use for filtering/preference
 * @param {String} options.filter (optional) - restrict results to the supplied city/state. Defaults to true if city/state present
 * @param {String} options.prefer (optional) - prefer results with the supplied city/state, but don't restrict. Defaults to false
 * @param {String} options.select (optional) - a callback on select,
 *          takes the signature function(event, ui){} where ui has an item property containing the selected result
 * @param {String} options.format (optional) - change the default result formatting
 * @param {String} options.apiMethod (optional) - make a server-side API call ('server') or client-side API call ('client'). Defaults to client.
 **/
function initAddressSearch(elementId, key, options) {
    const input = $(`input${elementId}`);// fix for uid and id being equal on the quoter
    // const input = $(elementId);
    let opts = options || {};
    let lastSearchResult = '';

    //parseInt returns NaN if opts.delay is undefined or false, in that case then use 500ms as default
    const optsDelay = isNaN(parseInt(window.smartystreets_delay)) ? 500 : parseInt(window.smartystreets_delay);

    input.autocomplete({
        autoFocus: true,
        delay: optsDelay,
        minLength: 2,
        select: function (event, ui) {
            input.val(ui.item.value);
        },
        change: function (event, ui) {
            if (!ui.item && lastSearchResult) {
                input.val(lastSearchResult);
            }
        },
        response: function (event, ui) {
            if (ui.content.length === 0) {
                const value = $(this).val();
                ui.content.push({
                    label: value,
                    value: value,
                    userSubmitted: true
                });
            } else {
                const formatFunc = opts.format || function (result) {
                    result.label = result.text;
                    result.value = result.text;
                };
                ui.content.forEach(formatFunc);
            }
        },
        search: function (event, ui) {
            lastSearchResult = input.val();
        },
        source: function (request, response) {
            const data = {
                search: request.term,
                max_results: '5',
                prefer_geolocation: 'none',
                key: key,
                license: 'us-autocomplete-pro-cloud'
            };

            if (opts.zipcode !== undefined && opts.zipcode) {
                data.prefer_zip_codes = opts.zipcode;
            }

            //Check for actual street name, not just numbers. It is useless to search on just numbers
            if (!request.term.match(/[A-Za-z]/gi)) {
                return;
            }

            fetchAutocompleteData(data, request, response);
        }
    });

    function fetchAutocompleteData(data, request, response, apiMethod) {
        // Defaulting to server-side address lookups
        apiMethod = 'server';

        const url = apiMethod === 'server' ? '/address_autocomplete' : 'https://us-autocomplete-pro.api.smartystreets.com/lookup';

        $.get(url + '?' + new URLSearchParams(data))
            .done(res => {
                if (res.suggestions !== undefined) {
                    const results = dedupeResults(res.suggestions);
                    response(results || []);
                } else {
                    response(res || []);
                }
            })
            .fail(error => {
                if (error.responseText.search('cloud') >= 0) {
                    fetchAutocompleteData(data, request, response, 'server');
                }
                console.error(error);
            });
    }

    function dedupeResults(results) {
        const uniqueResults = [];
        for (let i = 0; i < results.length; i++) {
            if (uniqueResults.find(element => element.street_line === results[i].street_line) === undefined) {
                uniqueResults.push(results[i]);
            }
        }

        return uniqueResults;
    }

    if (opts.select) {
        $(elementId).on('autocompleteselect', opts.select);
    }

    $(elementId).on('autocompletechange', function (event, ui) {
        if (!ui.item && !this.value) {
            $(this).val('').attr('placeholder', 'Address (try again - choose from the list)');
        }
    });

    $(elementId).on('keypress', function (e) {
        if (e.which === 13) {
            return false;
        }
    });

    return {
        setOpts: function(options) {
            opts = Object.assign(opts, options || {});
        }
    }
}

/**
 * Verify an address and trigger the callback with the result
 * Will populate a multi-address modal if more than one result is returned. For multiple addresses, callback is triggered when the modal is closed
 * @param {Object} searchTerms - address elements to verify
 * @param {String} searchTerms.street
 * @param {String} searchTerms.secondary (optional)
 * @param {String} searchTerms.city
 * @param {String} searchTerms.state
 * @param {Function} callback - called with the result if valid, or undefined if not
 */
function verifyAddress(searchTerms, callback) {
    $.ajax({
        url: '/address_verify',
        dataType: 'json',
        data: {
            street: searchTerms.street,
            secondary: searchTerms.secondary,
            city: searchTerms.city,
            state: searchTerms.state
        },
        success: function (result) {
            if (result && result.length > 0) {
                if (result.length > 1) {
                    _buildMultiAddressModal(result);
                    $('#address_search_multi_modal').foundation('reveal', 'open');
                    $('#address_search_multi_btn').on('click', function () {
                        $('#address_search_multi_btn').off();
                        $('#address_search_multi_modal').foundation('reveal', 'close');
                    });

                    this.closeHandler = _onMultiAddressModalClose.bind(this, result, callback);
                    $(document).on('close.fndtn.reveal', '#address_search_multi_modal', this.closeHandler);
                } else {
                    callback(result[0]);
                }
            } else {
                callback(undefined);
            }
        },
        error: function () {
            callback(undefined);
        }
    });
}

function _buildMultiAddressModal(result) {
    const addressList = $('#address_search_multi_list');
    addressList.empty();

    result.forEach(function (address, index) {
        const text = address.delivery_line + ',  ' + address.last_line;

        const input = $('<input>', {
            'class': 'custom-radio',
            'id': 'address_search_multi_choice_' + (index + 1),
            'name': 'address_search_multi_choice',
            'type': 'radio',
            'value': index + ''
        });

        if (index === 0) {
            input.prop('checked', true);
        }

        const label = $('<label>', {
            'class': 'custom-radio-label',
            'for': 'address_search_multi_choice_' + (index + 1),
            'text': text
        });

        const listItem = $('<li>');
        listItem.append(input);
        listItem.append(label);
        addressList.append(listItem);
    });
}

function _onMultiAddressModalClose(result, callback) {
    const index = $('input:radio[name=address_search_multi_choice]:checked').val();
    callback(result[index]);
    $(document).off('close.fndtn.reveal', '#address_search_multi_modal', this.closeHandler);
}

export{initAddressSearch, verifyAddress}